import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { VALIDATION } from 'helpers/constants';
import { useStore } from 'hooks';
import { Button } from 'components/ui/form';
import { Input } from 'components/ui/formik';
import AuthHelper from 'helpers/auth';
import styles from './recovery-password.module.scss';
import logoSi from '../../../assets/images/logo_si.png';
import patternImg from '../../../assets/images/pattern-left-side.png';

const EmailValidationSchema = Yup.object().shape({
  email: Yup.string()
    .email(...VALIDATION.EMAIL)
    .required(...VALIDATION.REQUIRED),
});

const RecoveryPasswordPage = ({ history }) => {
  const { setLoading, setUser } = useStore();
  const patternStyle = { backgroundImage: `url(${patternImg})` };

  return (
    <main className="page-login">
      <Formik
        initialValues={{
          email: '',
        }}
        validationSchema={EmailValidationSchema}
        onSubmit={({ email }) => {
          AuthHelper.sendEmail(
            email,
            { setLoading, setUser },
          );
        }}
      >
        {({
          handleSubmit,
        }) => (
          <form onSubmit={handleSubmit} className={styles.login} autoComplete="off">
            <div className={styles.head}>
              <div className={styles.title}>Введите ваш e-mail</div>
              <img src={logoSi} alt="Гранит" className={styles.logo} />
            </div>
            <div className={styles.fields}>
              <div className={styles.field}>
                <Input name="email" placeholder="Ваш e-mail" />
              </div>
            </div>
            <div className={styles.actions}>
              <div className={styles.restore}>
                <Button
                  color="transparent"
                  onClick={() => history.push('/login')}
                >
                  Назад
                </Button>
              </div>
              <div className={styles.submit}>
                <Button type="submit">Отправить</Button>
              </div>
            </div>
          </form>
        )}
      </Formik>
      <div className={styles.patternBottomRight} style={patternStyle} />
    </main>
  );
};

export default RecoveryPasswordPage;
